/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, type AgGridClientQuery, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/CreateCsvForTourOperator
 */
export interface CreateCsvForTourOperatorRequestBuilder extends BaseRequestBuilder<CreateCsvForTourOperatorRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<CreateCsvForTourOperatorRequestBuilderPostQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<CreateCsvForTourOperatorRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface CreateCsvForTourOperatorRequestBuilderPostQueryParameters {
    showUpToDate?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const CreateCsvForTourOperatorRequestBuilderUriTemplate = "{+baseurl}/Allotment/CreateCsvForTourOperator?showUpToDate={showUpToDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CreateCsvForTourOperatorRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CreateCsvForTourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
